import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { CellMappingStore } from './types';

const useCellMappingStore = create<CellMappingStore>()(
  devtools(
    (set, get) => ({
      cellMapping: {},
      getCellMapping: () => get().cellMapping,
      setCellMapping: cellMapping => set(() => ({ cellMapping })),
      updateCellMapping: newMapping => 
        set(state => ({ 
          cellMapping: { ...state.cellMapping, ...newMapping } 
        })),
      clearCellMapping: () => set(() => ({ cellMapping: {} })),
    }),
    {
      name: 'CellMappingStore',
    }
  )
);

export default useCellMappingStore;